import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertDialogService } from '../components/modals/alert-dialog.service';
import { UserRightsService } from './user-rights.service';

@Injectable({
  providedIn: 'root'
})
export class RoleRightGuard implements CanActivate {
  constructor(private userRights: UserRightsService, private router: Router , private alertDialogService: AlertDialogService) {}
  // tslint:disable-next-line: typedef
  canActivate(next: ActivatedRouteSnapshot) {
    const allowedRoleRights = next.data.allowedRights;
    if (!this.userRights.getUserRightsIsEnabledWithKey(allowedRoleRights[0])) {
      this.router.navigateByUrl('login');
      return false;
    }
    return true;
  }
}
